import{ React, useState, useEffect, LoaderOverlay, withAuth,connect,useSelector,useNavigate,useParams } from './../../common/helper/common-imports.component.js';
import {initialErrors} from '../../common/helper/form-constants.js';
import DataTable from 'react-data-table-component';
import StatusBadge from '../../common/helper/transaction-status.component.js';
import cashoutService from '../../../services/cashout-service.js';

const ViewCashoutComponent = () => { 
  const [loading, setLoading] = useState(false);
  const userData = useSelector(state => state.authReducer);
  const [errors, setErrors] = useState({ ...initialErrors });
  const [batch,setBatch] =useState({})
  const [searchTerm, setSearchTerm] = useState('');
  const [selectedRows, setSelectedRows] = React.useState([]);

  const [transactions,setTransactions] =useState([])
  const selectRows =  React.useCallback(state => {
    setSelectedRows(state.selectedRows);
}, []);
  const navigate = useNavigate();
  const { id } = useParams();

  const [role,setUserRole] = useState();
  const [rowsPerPage, setRowsPerPage] = useState(25);
  const [dataTableKey, setDataTableKey] = useState(0);
  const paginationComponentOptions = { 
    noRowsPerPage :true
  }
  const viewTransaction = (id) => {
    navigate(`/transaction/${id}`)
  }
  const handleRowsPerPageChange = (e) => {
    setRowsPerPage(Number(e.target.value));
    setDataTableKey(prevKey => prevKey + 1);
  };
  const escapeRegExp = (string) => {
    return string.replace(/[.*+\-?^${}()|[\]\\]/g, '\\$&'); // $& means the whole matched string
  };
  const [columns, setColumns] = useState([
    {
      name: 'Order ID',
      cell: row => <div className="custom-cell-order_Code"><a href="javascript:void(0)" onClick={() => viewTransaction(row.transaction_id)}>{row.order_code}</a></div>,
      sortable: true,
     
    },
    {
      name: 'Payment Type',
      selector: row => <>
      <div style={{ color: row.transaction_type.toLowerCase() === 'payin' ? 'green' : 'red' }}><i className="fa fa-money me-1" style={{ color: row.transaction_type.toLowerCase() === 'payin' ? 'green' : 'red' }} />
      {row.transaction_type.toLowerCase().charAt(0).toUpperCase() + row.transaction_type.toLowerCase().slice(1)}
      </div>
      </>,
      sortable: true,
    },
    {
      name: 'Date',
      selector: row =>  <div className="custom-cell-order_Code">{row.start_date}</div>,
      sortable: true,
    },
    {
      name: 'Status',
      selector: row => 
      <>
      <StatusBadge status={row.status} />

      </>,
      
      sortable: true,
    },
    {
      name: 'Amount',
      selector: row => '₹' + row.amount,
      sortable: true,
    },
    {
      name: 'Payment Method',
      selector: row => 
      <>
      <i className={`fa  me-1 ${
                            row.payment_method && row.payment_method.toLowerCase() === 'imps' ? 'fa-money' :
                            row.payment_method && row.payment_method.toLowerCase() === 'wallet' ? 'fa-credit-card' :
                            row.payment_method && row.payment_method.toLowerCase() === 'upi' ? 'fa-google-wallet' :
                            row.payment_method && row.payment_method.toLowerCase() === 'qr' ? 'fa-qrcode ' :
                            ''}`} /> {row.payment_method || '-'}
      
      </>
      
      ,
      sortable: true,
    },
   
  ]);
  const handleSearchChange = (e) => {
    setSearchTerm(e.target.value);
  };
  const excludedKeys = ['admin_detail'];

  const flattenValues = (obj) => {
    const values = [];
    const traverse = (item) => {
      if (Array.isArray(item)) {
        item.forEach((subItem) => traverse(subItem));
      } else if (typeof item === 'object' && item !== null) {
        Object.entries(item).forEach(([key, value]) => {
          if (!excludedKeys.includes(key)) {
            traverse(value);
          }
        });
      } else {
        values.push(item);
      }
    };
    traverse(obj);
    return values;
  };
  const filteredData = transactions && transactions.filter((row) => {
    const flattenedValues = flattenValues(row);
  
    // Apply the search on the flattened array of values
    return flattenedValues.some(
      (value) => new RegExp(escapeRegExp(searchTerm), 'i').test(value)
    );
  });
  const getBatchDetails = () => {
    setLoading(true);
    cashoutService.batchDetails(id)
      .then(response => {
        console.log(response)
        setBatch(response.data.data)
        setTransactions(response.data.data.transactions)
        setLoading(false);
      })
      .catch(error => {
        setLoading(false);
        console.error("Error fetching agents:", error);
      });
   
  }


    useEffect(() => {
      getBatchDetails()
      setUserRole(userData.user.data.role.role_code.toLowerCase())
      
        document.body.style.backgroundColor = '#f0f6fa';
        return () => {
          document.body.style.backgroundColor = ''; // Reset body color when ComponentOne unmounts
        };
}, []);

const back = () => {
    navigate('/cashout'); 
  }
return (
<>
    <LoaderOverlay loading={loading} />
    <div className="container-fluid px-4" style={{paddingBottom: '30px'}}>
        <h4 style={{marginTop: 0, fontWeight: 700, fontSize: '16px'}}>Batch Details</h4>
        <div className="row ghty" style={{backgroundColor: 'white', height: 'auto', paddingBottom: '20px'}}>
          <ul className="nav nav-tabs">
            <li className="nav-item tbbtrn">
              <a className="nav-link active_tab1" id="list_per_details">Batch Information</a>
            </li>
          </ul>
          <div className="tab-content" style={{marginTop: '0px', padding: 0}}>
            <div className="tab-pane active" id="per_details">
              <div className="panel panel-default">
                <div className="panel-body" style={{padding: '0px'}}>
                  <div className="col-md-12" style={{border: '1px solid #f7f7f7', borderRadius: '5px', padding: '13px'}}>
                  <div className="col-md-3" style={{padding: '0px', paddingRight: '15px'}}>
                      <div className="form-group frm" style={{textAlign: 'left'}}>
                        <label htmlFor="f_name">Batch ID</label>
                        <p>{batch.batch_id}</p>
                      </div>
                    </div>
                    <div className="col-md-3" style={{padding: '0px', paddingRight: '15px'}}>
                      <div className="form-group frm" style={{textAlign: 'left'}}>
                        <label htmlFor="f_name">Batch Code</label>
                        <p>{batch.batch_code}</p>
                      </div>
                    </div>
                    <div className="col-md-3" style={{padding: '0px', paddingRight: '15px'}}>
                      <div className="form-group frm" style={{textAlign: 'left'}}>
                        <label htmlFor="f_name">Record count</label>
                        <p>{batch.record_count}</p>
                      </div>
                    </div>
                    <div className="col-md-3" style={{padding: '0px', paddingRight: '15px'}}>
                      <div className="form-group frm" style={{textAlign: 'left'}}>
                        <label htmlFor="f_name">Record Amount</label>
                        <p>{batch.record_amount}</p>
                      </div>
                    </div>
                  
                    <div className="col-md-3" style={{padding: '0px', paddingRight: '15px'}}>
                      <div className="form-group frm" style={{textAlign: 'left'}}>
                        <label htmlFor="f_name">Pending Amount</label>
                        <p>{batch.pending_amount}</p>
                      </div>
                    </div>
                    <div className="col-md-3" style={{padding: '0px', paddingRight: '15px'}}>
                      <div className="form-group frm" style={{textAlign: 'left'}}>
                        <label htmlFor="f_name">Status</label>
                        <p><StatusBadge status={batch.status} />
                        </p>
                      </div>
                    </div>
                    <div className="col-md-3" style={{padding: '0px', paddingRight: '15px'}}>
                      <div className="form-group frm" style={{textAlign: 'left'}}>
                        <label htmlFor="f_name">Start Date</label>
                        <p>{batch.start_date}</p>
                      </div>
                    </div>
                    <div className="col-md-3" style={{padding: '0px', paddingRight: '15px'}}>
                      <div className="form-group frm" style={{textAlign: 'left'}}>
                        <label htmlFor="f_name">Finish Date</label>
                        <p>{batch.finish_date || '-'}</p>
                      </div>
                    </div>
           </div>
               </div>
                  </div>
                    </div>
          </div>
          <ul className="nav nav-tabs">
          <li className="nav-item tbbtrn">
            <a className="nav-link active_tab1" id="list_per_details">Transactions</a>
          </li>
        </ul>
        <div className="tab-content" style={{marginTop: '0px', padding: 0}}>
            <div className="tab-pane active" id="per_details">
              <div className="panel panel-default">
                <div className="panel-body" style={{padding: '0px'}}>
                  <div className="col-md-12" style={{border: '1px solid #f7f7f7', borderRadius: '5px', padding: '13px'}}>
                  <div className="filterBtn">
                        
                        <div id="examplemgm_filter" className="dataTables_filter"><label><input type="search" className placeholder="Search..."  value={searchTerm}
                        onChange={handleSearchChange} aria-controls="examplemgm" /></label></div>
                       
                  </div>
                  <div className="dataTables_length" id="examplemgm_length">
                                    <label>Show &nbsp;</label>
                      <select value={rowsPerPage} name="examplemgm_length" onChange={handleRowsPerPageChange}>
                       
                        <option value={25}>25</option>
                        <option value={50}>50</option>
                        <option value={100}>100</option>
                      </select>
                      &nbsp;entries
                    </div>
                      <div className="tab-content" id="nav-tabContent" style={{paddingTop: '15px'}}>
                        <div className="tab-pane fade show active" id="nav-home" role="tabpanel" aria-labelledby="nav-home-tab" style={{position: 'relative'}}>


                        <DataTable key={dataTableKey}
                            columns={columns}
                              data={filteredData}
                              pagination
                              paginationComponentOptions={paginationComponentOptions} 
                              paginationPerPage={rowsPerPage} 
                              onSelectedRowsChange = {selectRows}
                        />
                        </div>
                      </div>
                      <button type="button" style={{'marginTop':'9px'}} name="btn_login_details" id="btn_login_details" className="btn backbt" onClick={back}>Back</button>
             </div>
               </div>
                  </div>
                    </div>
          </div>
          
        </div>

      </div>
    </>
  );

}

 
function mapStateToProps(state) {
    const userData = state.authReducer.user;
    return { userData };
  }
export default withAuth(connect(mapStateToProps)(ViewCashoutComponent));